import { Policy, Risk } from '@amfam/policy/models';

export class ClaimRisk {
  public policy: Policy;
  public risk: Risk;
}
